import authentication from "./authentication";
import dashboard from "./dashboard";
import customers from "./customers";
import posts from "./posts";
import transactions from "./transactions";
import trip_plans from "./trip_plans";
import admin from "./admin";

export default {
  authentication,
  dashboard,
  customers,
  posts,
  transactions,
  trip_plans,
  admin,
};



// WEBPACK FOOTER //
// ./client/react/Admin/actions/index.js